
interface BenefitsSectionProps {
  serviceType: 'drafting' | 'takeoff';
}

export default function BenefitsSection({ serviceType }: BenefitsSectionProps) {
  const draftingBenefits = [
    {
      icon: 'ri-time-line',
      title: 'Fast Turnaround',
      description: 'Quick delivery without compromising quality, meeting your project deadlines consistently'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Code Compliant',
      description: 'All drawings meet local building codes and regulatory requirements for smooth permit approval'
    },
    {
      icon: 'ri-team-line',
      title: 'Expert Team',
      description: 'Experienced drafters and engineers with deep knowledge across multiple disciplines'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Cost Effective',
      description: 'Competitive pricing with transparent quotes and no hidden fees for budget certainty'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Unlimited Revisions',
      description: 'We work with you until the drawings perfectly match your vision and requirements'
    },
    {
      icon: 'ri-file-cloud-line',
      title: 'Multiple Formats',
      description: 'Receive files in CAD, PDF, and other formats compatible with your workflow'
    }
  ];

  const takeoffBenefits = [
    {
      icon: 'ri-focus-3-line',
      title: 'Precision Accuracy',
      description: 'Detailed measurements and calculations ensuring minimal material waste and cost overruns'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Competitive Bidding',
      description: 'Accurate estimates help you submit winning bids while maintaining healthy profit margins'
    },
    {
      icon: 'ri-database-2-line',
      title: 'Comprehensive Data',
      description: 'Complete breakdowns of materials, labor, equipment, and overhead for full transparency'
    },
    {
      icon: 'ri-timer-flash-line',
      title: 'Quick Turnaround',
      description: 'Fast delivery of takeoff reports to keep your bidding and planning on schedule'
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Budget Control',
      description: 'Detailed cost analysis helps identify savings opportunities and control project expenses'
    },
    {
      icon: 'ri-file-excel-2-line',
      title: 'Flexible Formats',
      description: 'Reports delivered in Excel, PDF, or your preferred estimating software format'
    }
  ];

  const benefits = serviceType === 'drafting' ? draftingBenefits : takeoffBenefits;

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose Our {serviceType === 'drafting' ? 'Drafting' : 'Takeoff'} Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Experience the advantages of working with industry professionals committed to your success
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-orange-50 rounded-xl mb-6 group-hover:bg-[#e18033] transition-colors">
                <i className={`${benefit.icon} text-3xl text-[#e18033] group-hover:text-white transition-colors`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {benefit.title}
              </h3>
              
              <p className="text-sm text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
